import React from "react";
import { Routes, Route } from "react-router-dom";
import AuthWrapper from "./AuthWrapper";

import AdminLayout from "components/AdminLayout";
import UserLayout from "components/UserLayout";

import Admin from "pages/Admin";
import AdminCategoria from "pages/AdminCategoria";
import AdminCategoriaRegistro from "pages/AdminCategoriaRegistro";
import AdminQuestao from "pages/AdminQuestao";
// import AdminQuestaoRegistro from "pages/AdminQuestaoRegistro";
import AdminQuestaoRegistroTextEditor from "pages/AdminQuestaoRegistroTextEditor";
import Relatorio from "pages/Relatorio";
import EditarUsuario from "pages/Usuario/Editar";
import Usuario from "pages/Usuario";
import Login from "pages/Login";
import Home from "pages/Home";

import Quiz from "pages/Quiz";
import Resumo from "pages/Resumo";
import PageNotFound from "pages/PageNotFound";
import RegistrarUsuario from "pages/RegistrarUsuario";
import RedefinirSenha from "pages/RedefinirSenha";
import ContentRecoveryEmailSent from "pages/RedefinirSenha/Content/ContentRecoveryEmailSent";
import RecoverPassword from "pages/RedefinirSenha/EmailRecuperacaoEnviado";
import NewPassword from "pages/RedefinirSenha/NovaSenha";
import PasswordChanged from "pages/RedefinirSenha/SenhaAlterada";
import ContentRegistroSucesso from "pages/RegistrarUsuario/ContentMensageUser";
import ContentReporteErro from "pages/ReporteErro/ContentReporteErro";

const dashboard = <h1>Dashboard</h1>;

const AppRoutes = () => {
  return (
    <Routes>
      <Route
        path="/admin/*"
        element={
          <AuthWrapper isAdmin>
            <AdminLayout />
          </AuthWrapper>
        }
      >
        <Route path="relatorio" element={<Relatorio />} />
        <Route path="usuarios/editar" element={<EditarUsuario />} />
        <Route path="usuarios" element={<Usuario />} />
        <Route
          path="questao/registro"
          element={<AdminQuestaoRegistroTextEditor />}
        />
        {/* <Route path="questao/registro" element={<AdminQuestaoRegistro />} /> */}
        <Route path="questao" element={<AdminQuestao />} />
        <Route path="categoria/registro" element={<AdminCategoriaRegistro />} />
        <Route path="categoria" element={<AdminCategoria />} />
        <Route path="" element={<Admin />} />
        <Route path="*" element={<PageNotFound />} />
      </Route>

      <Route
        path="/*"
        element={
          <AuthWrapper isPrivate>
            <UserLayout />
          </AuthWrapper>
        }
      >
        <Route path="" element={<Home />} />
        <Route path="resumo" element={<Resumo />} />
        <Route path="quiz" element={<Quiz />} />
        <Route path="reporte-erro" element={<ContentReporteErro />} />
        <Route path="dashboard" element={dashboard} />
        <Route path="*" element={<PageNotFound />} />
      </Route>
      <Route path="/*">
        <Route path="registro-sucesso" element={<ContentRegistroSucesso />} />
        <Route exact path="novasenha" element={<NewPassword />} />
        <Route path="senha-alterada" element={<PasswordChanged />} />
        <Route path="email-recuperacao-enviado" element={<RecoverPassword />} />
        <Route path="redefinir-senha" element={<RedefinirSenha />} />
        <Route path="cadastrar-usuario" element={<RegistrarUsuario />} />
        <Route path="login" element={<Login />} />
        <Route path="*" element={<PageNotFound />} />
      </Route>
    </Routes>
  );
};

export default AppRoutes;
